import PropTypes from 'prop-types';
import React from 'react';
import { Alert, Card } from 'react-bootstrap';
import { ImagesLayout } from './ImagesLayout';

export const ImagesUpload = ({
  data,
  setData,
  setStepStatus,
  replaceImagesInData,
  uploading,
  handleImages,
  type,
  accessor,
  title,
  parent
}) => {
  return (
    <>
      <Card.Title className="mb-3 fs-3">{title}</Card.Title>

      <Alert variant="info">
        <p className="mb-0">
          La edición de imágenes guarda automáticamente los cambios. No es
          necesario guardar manualmente. <br />
          Las imágenes no pueden pesar más de 5 MB cada una. <br /> No hay
          límite total de subida, pero solo se puede subir hasta 20 MB por vez.
          <br /> Los formatos aceptados son jpg, jpeg, y png.
        </p>
      </Alert>

      <Card className="bg-white mb-3">
        <Card.Body className="text-center">
          <ImagesLayout
            images={data[accessor]}
            data={data}
            setData={setData}
            setStepStatus={setStepStatus}
            propId={data._id}
            replaceImagesInData={replaceImagesInData}
            uploading={uploading}
            accessor={accessor}
            handleImages={handleImages}
            type={type}
            parent={parent}
          />
        </Card.Body>
      </Card>
    </>
  );
};
ImagesUpload.propTypes = {
  data: PropTypes.object,
  setData: PropTypes.func,
  setStepStatus: PropTypes.func,
  replaceImagesInData: PropTypes.func,
  uploading: PropTypes.bool,
  handleImages: PropTypes.func,
  type: PropTypes.oneOf(['image', 'houseMap']),
  title: PropTypes.string,
  accessor: PropTypes.oneOf(['images', 'houseMaps']),
  parent: PropTypes.oneOf(['property', 'project']).isRequired
};
